import React from 'react'
import ImageAndParagraph from '../../imageAndParagraph/imageAndParagraph'
import { useTheme } from '@chakra-ui/react';
import path22 from '../../../innerAsstes/Seccion trayecto/Recurso 22trayecto.png';
import path23 from '../../../innerAsstes/Seccion trayecto/Recurso 23trayecto.png';
import path24 from '../../../innerAsstes/Seccion trayecto/Recurso 24trayecto.png';
import { useAppContext } from '../../../App';
import { redireccionarWhatsApp } from '../../../utils/functions';

export default function PathSteps() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  return (
    <div style={style.container}>
      <ImageAndParagraph
        imgSrc={path24}
        fontFamily={'sansation-bold'}
        customStyles={style.customFirst}
        titleFirst={"Vos dá el primer paso y te ayudamos"}
        titleSecond={"A ELEGIR LA MEJOR RUTA"}
      />
      <ImageAndParagraph
        imgSrc={path23}
        customStyles={style.customSecond}
        fontFamily='quicksand-semibold'
        buttonText='Quiero que me contacte UN REPRESENTANTE'
        buttonCustomActions={redireccionarWhatsApp}
        description={`Nuestros representantes están aquí para
            guiarte en cada paso del camino. Comunicate
            con ellos para explorar cómo tus habilidades y
            formación actual pueden conducirte hacia
            NUEVAS OPORTUNIDADES PROFESIONALES.`}
      />
      <ImageAndParagraph
        imgSrc={path22}
        customStyles={style.customThird}
        className='quicksand-semibold'
        buttonText='Saber más'
        buttonRedirectTo='/comunidad'
        description={`Además, como parte de la
            COMUNIDAD GESTAR,
            obtenes grandes descuentos
            para tus cursos.`}
      />
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    paddingBottom: '1rem',
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: theme.background.primary,
  },
  customFirst: {
    container: {
      display: "flex",
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
    },
    textContainer: {
      width: isMobile? "100%":"25%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    title1: {
      fontSize: isMobile? '1rem':'3.5rem',
      color: theme.color.text.secondary,
      textAlign: "center",
      lineHeight: 1
    },
    title2: {
      fontSize: isMobile? '1rem':'3.5rem',
      textAlign: "center",
      lineHeight: 1
    },
    img: { width: "50%", height: "100%"},
    buttonStyles: {
      container:{
        width: isMobile? '60%':'30%',
        height: '5vh',
        marginTop: '2rem',
        padding: '0.5rem',
        justifyContent: 'space-around',
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.6)",
      },
      text:{
        fontSize: '1.5rem',
        width: 'auto',
      },
      arrowSvg:{
        width:'20%',
        height:'100%',
      },
    }
  },
  customSecond: {
    container: {
      width: "100%",
      display: "flex",
      flexDirection: isMobile? "column":"row",
      alignItems: isMobile? "":"center",
      justifyContent: "center",
    },
    img: {
      padding: 0,
      margin:0,
      display: "flex",
      justifyContent: "flex-end",
    },
    description: {
      width: isMobile? "100%":"85%",
      fontSize: isMobile? "1.5rem":"2rem",
      paddingRight: isMobile? 0:"4rem",
      color: theme.color.text.primary,
      textAlign: "left",
      lineHeight: 1,
    },
    buttonStyles:{
      container:{
        width: isMobile? '70%': '50%',
        height: 'auto',
        marginTop: '2rem',
        padding: '0.5rem',
        paddingLeft: isMobile? '0.5rem' : '2rem',
        paddingRight: isMobile? '0.5rem' : '2rem',
        justifyContent: 'space-between',
        textAlign: 'left',
        alignSelf: 'start',
      },
      text:{
        fontSize: isMobile? '0.7rem':'1.5rem'
      },
      arrowSvg:{
        width:'20%',
      }
    }
  },
  customThird: {
    container: {
      display: "flex",
      flexDirection: isMobile? "column":"row-reverse",
      justifyContent: "center",
      alignItems: "end",
      marigin: 0,
      padding: 0,
    },
    textContainer: {
      width: isMobile? "100%":"40%",
      padding: "1rem",
      paddingLeft: "3rem",
      paddingBottom: "2rem",
      backgroundColor: theme.background.secondary,
    },
    description: {
      width: isMobile? "100%":"80%",
      fontSize: isMobile? "1.5rem":"2rem",
      lineHeight: 1.2,
      textAlign: "left",
      color: theme.color.text.primary,
    },
    img: {
      display: "none",
    },
  },
});
